import TrainsOnewayBaseController from '../../trains-base/controllers/trains-oneway-base-controller';

export default function TrainsOnewayController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(TrainsOnewayBaseController, {
        $scope,
        trainsFactory,
        cfg: {
            resultsRoute: 'main.trains.results',
        },
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-oneway-controller.js